import { itemImage, type ItemAssetId } from '@/lib/assets';

export type ItemCategory = 'currency' | 'weapon' | 'consumable' | 'special' | 'treasure';

export interface ItemMeta {
  id: ItemAssetId;
  name: string;
  icon: string;
  category: ItemCategory;
  description: string;
}

export const ITEMS: Record<ItemAssetId, ItemMeta> = {
  doubloon: {
    id: 'doubloon',
    name: 'Doubloon',
    icon: itemImage('doubloon'),
    category: 'currency',
    description: 'The coin of the Caribbean. Spend it or hoard it.',
  },
  pirate_mark: {
    id: 'pirate_mark',
    name: 'Pirate Mark',
    icon: itemImage('pirate_mark'),
    category: 'currency',
    description: 'Premium scrip of the pirate underworld.',
  },
  cutlass: {
    id: 'cutlass',
    name: 'Cutlass',
    icon: itemImage('cutlass'),
    category: 'weapon',
    description: 'The workhorse of the boarding party.',
  },
  flintlock_pistol: {
    id: 'flintlock_pistol',
    name: 'Flintlock Pistol',
    icon: itemImage('flintlock_pistol'),
    category: 'weapon',
    description: 'One shot, one chance. Make it count.',
  },
  blunderbuss: {
    id: 'blunderbuss',
    name: 'Blunderbuss',
    icon: itemImage('blunderbuss'),
    category: 'weapon',
    description: 'Close quarters, devastating spread.',
  },
  boarding_axe: {
    id: 'boarding_axe',
    name: 'Boarding Axe',
    icon: itemImage('boarding_axe'),
    category: 'weapon',
    description: 'Splits wood, rope, and bone alike.',
  },
  tankard_of_rum: {
    id: 'tankard_of_rum',
    name: 'Tankard of Rum',
    icon: itemImage('tankard_of_rum'),
    category: 'consumable',
    description: 'Restores Happy and dulls the pain.',
  },
  treasure_chest_closed: {
    id: 'treasure_chest_closed',
    name: 'Treasure Chest (Sealed)',
    icon: itemImage('treasure_chest_closed'),
    category: 'treasure',
    description: 'Heavy, locked, and full of promise.',
  },
  treasure_chest_open: {
    id: 'treasure_chest_open',
    name: 'Treasure Chest (Open)',
    icon: itemImage('treasure_chest_open'),
    category: 'treasure',
    description: 'The reveal. The rush.',
  },
  brass_compass: {
    id: 'brass_compass',
    name: 'Brass Compass',
    icon: itemImage('brass_compass'),
    category: 'special',
    description: 'Guides the way when stars fail you.',
  },
  scroll: {
    id: 'scroll',
    name: 'Scroll',
    icon: itemImage('scroll'),
    category: 'special',
    description: 'Orders, contracts, or secrets — sealed in wax.',
  },
};
